import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var RadioButton = function RadioButton(props) {
  var className = props.className,
      label = props.label,
      value = props.value,
      onChange = props.onChange;

  var _useState = useState(value || false),
      selected = _useState[0],
      setSelected = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setSelected(value || false);
  }, [value]);
  /**
   * methods
   */

  var clickAction = function clickAction() {
    onChange === null || onChange === void 0 ? void 0 : onChange(!selected);
  };

  var selectStyles = {};
  if (selected) selectStyles['backgroundColor'] = 'rgba(51, 51, 51, 0.03)';
  return /*#__PURE__*/_jsx("div", {
    style: selectStyles,
    className: clsx('flex h-14 w-full cursor-pointer items-center justify-center rounded border-2 border-[#e2e2e2]', {
      'border-[#333333]': selected
    }, className),
    onClick: clickAction,
    children: label
  });
};